import React from 'react';
import { Link } from 'react-router-dom';
import './QuoteSelection.css';
import { ChatCircle, Calculator } from 'phosphor-react';

const QuoteSelection = () => {
  return (
    <div className="quote-selection-container">
      <div className="quote-selection-content">
        <h1>Pedir Orçamento</h1>
        <p className="quote-selection-subtitle">
          Escolha a opção que melhor se adapta às suas necessidades
        </p>

        <div className="quote-options">
          <div className="quote-option quote-option-recommended">
            <div className="quote-recommended-badge">Recomendado</div>
            <div className="quote-option-icon quote-option-icon-primary">
              <ChatCircle size={48} />
            </div>
            <div className="quote-option-content">
              <h2>Orçamento Simples</h2>
              <p>
                Perfeito para quem não tem certeza sobre que produtos precisa. 
                Descreva as suas necessidades e nós ajudamos.
              </p>
              <ul className="quote-option-features">
                <li>Formulário simples e intuitivo</li>
                <li>Descreva as suas necessidades</li>
                <li>Consultoria gratuita</li>
                <li>Contacto personalizado da nossa equipa</li>
              </ul>
            </div>
            <Link to="/orcamento/simples" className="quote-option-btn quote-option-btn-primary">
              Pedir Orçamento Simples
            </Link>
          </div>

          <div className="quote-option">
            <div className="quote-option-icon">
              <Calculator size={48} />
            </div>
            <div className="quote-option-content">
              <h2>Orçamento Avançado</h2>
              <p>
                Ideal para quem conhece os produtos e pretende selecionar 
                equipamentos específicos do nosso catálogo.
              </p>
              <ul className="quote-option-features">
                <li>Seleção direta de produtos</li>
                <li>Especificações técnicas detalhadas</li>
                <li>Carrinho de orçamento personalizado</li>
                <li>Cálculo automático de quantidades</li>
              </ul>
            </div>
            <Link to="/orcamento/avancado" className="quote-option-btn quote-option-btn-secondary">
              Começar Orçamento Avançado
            </Link>
          </div>
        </div>

        <div className="quote-help">
          <h3>Não tem certeza qual escolher?</h3>
          <p>
            Se tem dúvidas sobre que produtos precisa ou como funciona a instalação, 
            recomendamos o <strong>Orçamento Simples</strong>. A nossa equipa entrará em contacto 
            para uma consultoria gratuita.
          </p>
        </div>

        <div className="quote-contact">
          <h3>Precisa de ajuda imediata?</h3>
          <p>
            Ligue-nos diretamente: <strong>+351 256 418 202</strong><br />
            Email: <strong>mlptelecomunicacoes@gmail.com</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default QuoteSelection;
